import "./TableFooter.scss"
import { MdKeyboardArrowLeft, MdKeyboardArrowRight, MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";

interface TableFooterProps {
  page: number;
  totalItems: number;
  itemsPerPage: number;
  goToPage: (page: number) => void;
}

export default function TableFooter(props: TableFooterProps) {

  const { page, totalItems, itemsPerPage, goToPage } = props;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const firstItemShowing = ((page - 1) * itemsPerPage) + 1;
  const lastItemShowing = Math.min((page * itemsPerPage), totalItems);

  return (
    <div className="table-footer">
      <div className="table-footer-text">
        Mostrando: {firstItemShowing}-{lastItemShowing} de {totalItems}
      </div>
      <div className="flex items-center">
        <button
          className={`footer-doubleArrow ${page === 1 ? 'disabled' : ''}`}
          disabled={page === 1}
          onClick={() => goToPage(1)}
        >
          <MdKeyboardDoubleArrowLeft className="footer-icons" />
        </button>
        <button
          className={`footer-doubleArrow ${page === 1 ? 'disabled' : ''}`}
          disabled={page === 1}
          onClick={() => goToPage(page - 1)}
        >
          <MdKeyboardArrowLeft className="footer-icons" />
        </button>

        <div
          className="mx-1 space-x-0.5 flex align-middle"
        >
          <button
            className={`page-button ${(page - 2) <= 0 ? 'disabled' : ''}`}
            disabled={(page - 2) === 0}
            onClick={() => goToPage(page - 2)}
          >
            {page - 2}
          </button>

          <button
            className={`page-button ${(page - 1) <= 0 ? 'disabled' : ''}`}
            disabled={(page - 1) === 0}
            onClick={() => goToPage(page - 1)}
          >
            {page - 1}
          </button>

          <button
            className="page-button focus"
            onClick={() => goToPage(page)}
          >
            {page}
          </button>

          <button
            className={`page-button ${(page + 1) >= (totalPages) ? 'disabled' : ''}`}
            onClick={() => goToPage(page + 1)}
          >
            {page + 1}
          </button>

          <button
            className={`page-button ${(page + 2) >= (totalPages) ? 'disabled' : ''}`}
            onClick={() => goToPage(page + 2)}
          >
            {page + 2}
          </button>
        </div>

        <button
          className={`footer-doubleArrow ${page === totalPages ? 'disabled' : ''}`}
          disabled={page >= totalPages}
          onClick={() => goToPage(page + 1)}
        >
          <MdKeyboardArrowRight className="footer-icons" />
        </button>

        <button
          className={`footer-doubleArrow ${page === totalPages ? 'disabled' : ''}`}
          disabled={page >= totalPages}
          onClick={() => goToPage(totalPages)}
        >
          <MdKeyboardDoubleArrowRight className="footer-icons" />
        </button>

      </div>
    </div>
  );
}